import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import { InlineNotification } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/clips';

export type NotificationType = 'enrollmentError' | 'enrollmentSuccess' | 'enrollmentInformation' | undefined;

type OverlayProp = {
  overlayType: NotificationType;
  // purely for tracking purposes
  courseId?: string;
};

export const SFCEnrollmentNotification = (props: OverlayProp) => {
  const { overlayType, courseId } = props;
  const [isDismissed, setIsDismissed] = React.useState(false);

  React.useEffect(() => {
    setIsDismissed(false);
  }, [overlayType]);

  const dismissBanner = () => setIsDismissed(true);

  const notificationProps = {
    enrollmentError: {
      severity: 'error' as const,
      title: _t('This video is unavailable to watch!'),
      children: _t(
        'We’re sorry about this! Your automatic course enrollment was unsuccessful. Try refreshing this page or contact your administrator for support.'
      ),
      trackingName: 'enrollment_error',
    },
    enrollmentSuccess: {
      severity: 'success' as const,
      title: _t("You're enrolled!"),
      children: _t(
        'We’ve automatically enrolled you in this course for free. If you change your mind visit My Courses.'
      ),
      trackingName: 'enrollment_success',
    },
    enrollmentInformation: {
      severity: 'information' as const,
      title: _t('Keep going!'),
      children: _t(
        'You’re already more than 5% through the course. If you wish to continue, we will enroll you automatically for free. If you change your mind visit My Courses.'
      ),
      trackingName: 'enrollment_information',
    },
  };

  const router = useRouter();
  const orgSlug = router.location.query.org;
  const programSlug = router.location.query.program;
  const itemId = router.params?.itemId;

  if (isDismissed || !overlayType) return null;

  const trackingName = `sfc_enroll_notif_${notificationProps[overlayType].trackingName}`;

  return (
    <TrackedDiv
      withVisibilityTracking
      trackClicks={false}
      data={{ orgSlug, programSlug, itemId, courseId }}
      trackingName={trackingName}
    >
      <InlineNotification {...notificationProps[overlayType]} onDismiss={dismissBanner} />
    </TrackedDiv>
  );
};
